import { signInWithCustomToken, signOut } from 'firebase/auth';
import { auth } from './config';

const DEFAULT_EDUSICO_ORIGIN = 'https://edusico.cl';

/**
 * Lee authToken / idToken de la URL (query o hash) y limpia la barra de direcciones.
 */
export function extractEdusicoAuthTokensFromUrl() {
  if (typeof window === 'undefined') {
    return { authToken: '', idToken: '' };
  }

  const url = new URL(window.location.href);
  const searchParams = url.searchParams;
  const hashParams = url.hash ? new URLSearchParams(url.hash.replace(/^#/, '')) : null;

  const authToken =
    searchParams.get('authToken') ||
    searchParams.get('token') ||
    hashParams?.get('authToken') ||
    hashParams?.get('token') ||
    '';
  const idToken =
    searchParams.get('idToken') ||
    searchParams.get('id_token') ||
    hashParams?.get('idToken') ||
    hashParams?.get('id_token') ||
    '';

  if (authToken || idToken) {
    searchParams.delete('authToken');
    searchParams.delete('token');
    searchParams.delete('idToken');
    searchParams.delete('id_token');
    if (hashParams) {
      hashParams.delete('authToken');
      hashParams.delete('token');
      hashParams.delete('idToken');
      hashParams.delete('id_token');
      const nextHash = hashParams.toString();
      url.hash = nextHash ? `#${nextHash}` : '';
    }
    window.history.replaceState({}, document.title, url.toString());
  }

  return { authToken, idToken };
}

function edusicoApiOrigin() {
  return import.meta.env.VITE_EDUSICO_ORIGIN || DEFAULT_EDUSICO_ORIGIN;
}

/**
 * Aplica la sesión de Edusico en esta app (dominio distinto).
 * Cierra la sesión persistida anterior antes de firmar con el custom token.
 */
export async function applyEdusicoSsoFromUrl() {
  const { authToken, idToken } = extractEdusicoAuthTokensFromUrl();
  if (!authToken && !idToken) {
    return { applied: false };
  }

  if (auth.currentUser) {
    await signOut(auth);
  }

  if (authToken) {
    await signInWithCustomToken(auth, authToken);
    return { applied: true, method: 'authToken' };
  }

  const resp = await fetch(`${edusicoApiOrigin()}/api/auth/bridge`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    },
  });
  const data = await resp.json().catch(() => null);
  if (!resp.ok || !data?.token) {
    throw new Error(data?.error || 'No se pudo vincular la sesión desde Edusico');
  }

  await signInWithCustomToken(auth, data.token);
  return { applied: true, method: 'idToken' };
}
